<template>
  <div>
    <p class="mt-1">
      State legislative districts are required to have
      <a
        href="http://www.publicmapping.org/what-is-redistricting/redistricting-criteria-equal-population"
        target="_blank"
        >substantially equal</a
      >
      populations (they have more leeway than congressional districts).
    </p>

    <p>
      Other factors need to be considered, such as ensuring that redrawn
      districts
      <a
        href="https://redistricting.lls.edu/redistricting-101/where-are-the-lines-drawn/#minority+representation"
        target="_blank"
        >do not harm voters of color</a
      >, and that
      <a
        href="https://redistricting.lls.edu/redistricting-101/where-are-the-lines-drawn/#communities+of+interest"
        target="_blank"
        >communities of interest are preserved</a
      >. The charts below show
      <strong
        >{{ postgres.districtname }}'s population by race &amp; Hispanic
        origin</strong
      >
      according to the 2020 Census.
    </p>

    <!-- <PieChart :geoid="postgres.geoid" :popType="'cvap'"/> -->
     <PieChart v-if="postgres.geoid" :legBody="'statelegupper'" :geoid="postgres.geoid"/>


    <p class="text-caption">
      Note: "Amer. Indian/AK Native" = American Indian/Alaska Native;<br />"Nat.
      Haw./Other PI" = Native Hawaiian/Other Pacific Islander
      <br />
      <em>Percentages may not total 100% due to rounding.</em>
    </p>
  </div>
</template>
<script>
import { Enums } from "../../../../data/Config/Config";
import PieChart from "../../PieChart";
export default {
  name: "DemograhicsStUpper",
  components: {
    PieChart,
  },
  data: function () {
    return {};
  },
  mounted: function () {},
  methods: {},
  watch: {},
  computed: {
    postgres: function () {
      return (
        this.$store.getters.getSelectedData[Enums.DATA_SOURCE.POSTGRES] || {}
      );
    },
  },
};
</script>
<style></style>